import { withTranslation } from 'react-i18next';
import CheckData from '../../../components/CatchError';
import CommerceTabs from '../../../components/CommerceTabs';
import Component from '../../../components/Component';
import DataTable from '../../../components/Datatable';
import { changeIntent } from '../../../helpers/commerce';
import { getSortKeys, setAdditionalStyles } from '../../../helpers/table';
import ExtraBox from './extrabtns';
import { COLUMNS } from './keys';
import query from './query';
import { v4 as uuid } from 'uuid';

class CommerceViewDetailUrl extends Component {
    constructor(props) {
        super();

        this.url = new URL(window.location);
        const url = this.url.searchParams.get('url');
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.keyword = this.url.searchParams.get('keyword');

        this.query = query({ project_id: props.project_id, url });
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item?.keyword?.toLowerCase()?.includes(search.toLowerCase()));
    }

    componentDidUpdate(_, prevState) {
        if (this.state.data && JSON.stringify(this.state.data) !== JSON.stringify(prevState.data)) {
            const data = this.state.data?.map((x) => ({ id: uuid(), ...x }));
            this.setState({ allData: data });
        }
    }

    checkIntent(itemIntent, selectedIntent) {
        for (let i = 0; i < selectedIntent?.length; i++) {
            if (itemIntent.includes(selectedIntent[i])) return true;
        }
        return false;
    }

    async handleSelectChange(values) {
        const sortedValues = values?.length
            ? this.state.allData.filter((item) =>
                  this.checkIntent(
                      item.intent,
                      values?.map((item) => item.value),
                  ),
              )
            : this.state.allData;

        changeIntent(values);
        this.setState({
            select: values,
            sortedValues,
        });
    }

    render() {
        const { t } = this.props;
        const extraBtns = () => (
            <ExtraBox select={this.state.select} handleSelectChange={this.handleSelectChange} />
        );
        const data = this.state.sortedValues ?? this.state?.allData ?? [];
        return (
            <>
                <CommerceTabs project_id={this.props.project_id} keyword={this.keyword} />
                <div className="card rounded-main table-main">
                    <div>
                        <CheckData data={data} loading={this.state.loading}>
                            <DataTable
                                nodes={data}
                                sortFns={getSortKeys(COLUMNS(t))}
                                additionalBox={extraBtns}
                                COLUMNS={COLUMNS(t)}
                                header={'Commerce'}
                                fileName="Project"
                                searchFunction={this.searchFunction}
                                defaultSortKey={'position'}
                                additionalStyles={setAdditionalStyles(COLUMNS(t))}
                                customEmptyMessage="No Data available"
                            />
                        </CheckData>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(CommerceViewDetailUrl);
